import { AdminMembersTable } from './AdminMembersTable'

export default AdminMembersTable;